var cov_2hq3zzxp03 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tree/index.ts",
      hash = "e1c71887d908bdba3d9699e5ca0cf32c4439b3bf",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tree/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 15
        },
        end: {
          line: 5,
          column: 47
        }
      },
      "1": {
        start: {
          line: 6,
          column: 19
        },
        end: {
          line: 10,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import Tree from './Tree';
import inputable from '../Form/inputable';
var Select = (cov_2hq3zzxp03.s[0]++, inputable(Tree));
var TreeExport = (cov_2hq3zzxp03.s[1]++, Object.assign(Tree, {
  displayName: 'ShineoutTree',
  Select: Select,
  Field: Select
}));
export default TreeExport;